<template>
  <div :class="{'has-error': errorMessage}">
    <!--TEXT : It's a one line text input.-->
    <label class="control-label">{{ pieceName }}</label>
    <p class="piece-instructions" v-if="pieceOptions.instructions" v-html="pieceOptions.instructions"></p>
    <textarea
      v-model="content"
      type="text"
      :class="'form-control ' + pieceName"
      :name="'pieces[' + pieceIndex + '][content]'"
      class="messagearea step-messagearea one-line-input"
      @change="$emit('content-change', $event.target.value)"
    ></textarea>
    <span v-if="errorMessage" class="text-danger text-piece__error">{{ errorMessage }}</span>
    <div class="step-spacer"></div>
  </div>
</template>

<script>
import utils from '../../../../mixins/utils';

export default {
  name: 'text-piece',
  mixins: [utils],
  data() {
    return {
      content: '',
    };
  },
  props: {
    pieceId: {
      type: Number,
      required: true,
    },
    pieceIndex: {
      type: Number,
      required: true,
    },
    pieceName: {
      type: String,
      required: true,
    },
    pieceContent: {
      type: String,
      required: true,
    },
    pieceOptions: {
      type: Object,
      required: true,
    },
  },
  computed: {
    fieldIsRequired() {
      return this.pieceOptions.required === 'true';
    },
    errorMessage() {
      if (this.fieldIsRequired && this.content.length === 0) {
        return `${this.pieceName.charAt(0).toUpperCase() + this.pieceName.slice(1)} cannot be empty`;
      } else {
        return;
      }
    },
  },
  methods: {
    disableSavingForm(message) {
      this.$emit('disable-saving', {disabled: !!message, pieceId: this.pieceId, message});
    },
  },
  watch: {
    pieceContent: {
      immediate: true,
      handler(content) {
        this.content = this.stripSlashes(content);
      },
    },
    errorMessage: {
      immediate: true,
      handler(message) {
        this.disableSavingForm(message);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.text-piece {
  &__error {
    font-size: 14px;
  }
}
</style>
